import { RadioQuestion } from 'app/ui/components/radio-questions-list/RadioQuestionsList';

export const PERIMETER_CONTROLS = [
  { name: 'Silt Fence', id: 'silt_fence' },
  { name: 'Super Silt Fence', id: 'super_silt_fence' },
  { name: 'Temporary Diversion', id: 'temporary_diversion' },
  { name: 'Structures', id: 'structures' },
  { name: 'Silt Sock', id: 'silt_sock' },
  { name: 'Other', id: 'other' },
];

export const SEDIMENT_TRAPPINGS = [
  { name: 'Storm Drain Inlet Protection', id: 'storm_drain_inlet_protection' },
  { name: 'Culvert Inlet Protection', id: 'culvert_inlet_protection' },
  { name: 'Temporary Sediment Trap', id: 'temporary_sediment_trap' },
  {
    name: 'Stabilized Construction Entrance',
    id: 'stabilized_construction_entrance',
  },
  {
    name: 'Dewatering Structures and Operations',
    id: 'dewatering_structures_and_operations',
  },
  { name: 'Straw Bale Dikes', id: 'straw_bale_dikes' },
  { name: 'Vehicle Tire Wash Rack', id: 'vehicle_tire_wash_rack' },
  { name: 'Other', id: 'other' },
];

export const TEMPORARY_STABILIZATION = [
  {
    name: 'Stabilized Construction Entrance',
    id: 'stabilized_construction_entrance',
  },
  { name: 'Construction Road Stabilized', id: 'construction_road_stabilized' },
  { name: 'Rock Check Dams', id: 'rock_check_dams' },
  { name: 'Land Grading', id: 'land_grading' },
  { name: 'Temporary Seeding', id: 'temporary_seeding' },
  { name: 'Mulching', id: 'mulching' },
  { name: 'Other', id: 'other' },
];

export const SLOPE_PROTECTION = [
  { name: 'Temporary Diversion Dike', id: 'temporary_diversion_dike' },
  { name: 'Earth Berm', id: 'earth_berm' },
  {
    name: 'Slope Stabilization Structure',
    id: 'slope_stabilization_structure',
  },
  { name: 'Other', id: 'other' },
];

export const TREE_PROTECTION = [
  { name: 'Armoring', id: 'armoring' },
  { name: 'Trenchless Silt Fence', id: 'trenchless_silt_fence' },
  { name: 'Tree Protection Zone', id: 'tree_protection_zone' },
  { name: 'Other', id: 'other' },
];

export const TREE_PROTECTION_FAIL_MATRIX = [null, false, false];

export const TREE_PROTECTION_QUESTION_EXTENDED_ID = 'identifiedOnPlanProtected';
export const TREE_PROTECTION_QUESTION_SPECIAL_ID = 'specialTreesOnSite';

export const TREE_PROTECTION_QUESTIONS: RadioQuestion[] = [
  {
    id: TREE_PROTECTION_QUESTION_SPECIAL_ID,
    title: 'Are there special/heritage trees on site?',
    subtitle: '',
    state: null,
  },

  {
    id: 'identifiedOnPlan',
    title: 'Are all special/heritage trees identified on the plan?',
    subtitle: '',
    state: null,
  },
  {
    id: TREE_PROTECTION_QUESTION_EXTENDED_ID,
    title:
      'Are all special/heritage trees and critical root zones within the limits of disturbance protected?',
    subtitle: '',
    state: null,
  },
];
